
import { EntityName } from "lib-core"


export default EntityName
